<div class="ingredient-div">
  <div class="formula-quantity">
    <amount-slider class="form-ingr-slider" [title]="ingredientName" [noGradient]=true [restrictMax]=true [min]=0.5 [max]=max [amount]=ingredientQuantity [step]=0.5 [unit]=unit (onChange)="updateQuantity($event)" [unit]=unit></amount-slider>
  </div>
  <div class="delete">
    <ion-icon name="trash" (click)="deleteMe()"></ion-icon>
  </div>
</div>
